function toggleItem(id, model) {
  if (app.activatingOrDeactivatingItem == true) {
    return;
  }

  if ($('body').attr('data-user-role') == 'editor' && $('.list-item__row--body[data-id="' + id + '"] .list-item__icon--toggle-admin').length) {
    warning('Auf Freigabe warten')
    return;
  }

  var isActive =
    $('.list-item__row--body[data-id="' + id + '"]').attr('data-active') == '1';

  activateOrDeactivateRequest([id], model, !isActive);
}

function deactivateItems(model) {
  activateOrDeactivateItems(model, false);
}

function activateItems(model) {
  activateOrDeactivateItems(model, true);
}

function activateOrDeactivateItems(model, activate) {
  if (app.activatingOrDeactivatingItem == true) {
    return;
  }
  var ids = getSelectedIds();
  if (ids.length) {
    activateOrDeactivateRequest(ids, model, activate);
  }
  closeMultiselectOptions();
}

function activateOrDeactivateRequest(ids, model, activate) {
  var active = activate ? '1' : '0';

  $.ajax({
    url: '/admin/request/active',
    method: 'post',
    data: {
      ids: ids,
      model: model,
      active: active
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.activatingOrDeactivatingItem = true;
    },
    success: function (response) {
      app.activatingOrDeactivatingItem = false;
      if (response && response.success) {
        var selector = getMultiSelectRowsSelector(ids);
        $(selector).attr('data-active', active);
        success(
          getMultiSelectSuccessMessage(
            ids,
            activate ? ' aktiviert' : ' deaktiviert'
          )
        );
        $.each(ids, function (index, id) {
          if ($('body').attr('data-user-role') == 'admin') {
            $('.list-item__row--body[data-id="' + id + '"] .list-item__icon--toggle-admin').removeClass('list-item__icon--toggle-admin');
          }
        });
        if (
          ids.length == 1 &&
          app.tooltipRow &&
          (app.tooltipRow.content.html() == 'Aktivieren' ||
            app.tooltipRow.content.html() == 'Deaktivieren')
        ) {
          app.tooltipRow.setContent(activate ? 'Deaktivieren' : 'Aktivieren');
        }
        return;
      }
      error();
    },
    error: function () {
      app.activatingOrDeactivatingItem = false;
      ajaxError();
    }
  });
}
